/**
 * Persisted-id detection for optimistic write-through.
 *
 * Database rows use UUID primary keys, while optimistically-created local
 * entities use prefixed ids (`task-…`, `evt-…`, `list-…`). Store persistence
 * paths use this to decide whether a mutation can target the backend
 * directly or refers to a not-yet-reconciled optimistic entity.
 *
 * @module shared/lib/persistedId
 */

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when the id is a database UUID (persisted row). */
export function isPersistedId(id: string): boolean {
  return UUID_PATTERN.test(id);
}
